import { CONNECT_APP_ROUTE_PATHS } from "../components/constants";

export type AirOriginPath =
  | CONNECT_APP_ROUTE_PATHS.ADDITIONAL_FUNDING
  | CONNECT_APP_ROUTE_PATHS.HOME
  | CONNECT_APP_ROUTE_PATHS.IN_REVIEW;

const AIR_ORIGIN_REGEX = /\/funding\/application\/([^/]+)/;

export const getAirOriginPath = (pathname: string): AirOriginPath | undefined => {
  const match = AIR_ORIGIN_REGEX.exec(pathname);
  return match?.[1] as AirOriginPath | undefined;
};
